import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAccounts } from "../modules";
import { useAuth } from "./useAuth";
import { useUpdateCurrentAccount } from "./useCurrentAccount";
import { useValidSession } from "./useValidSession";
var useAppSelector = useSelector;
var useAppDispatch = function() {
    return useDispatch();
};
var transformMfaApiKeys = function(apiKeys) {
    var masterAccount = apiKeys.find(function(param) {
        var master = param.master;
        return master;
    });
    var accounts = [];
    if (masterAccount && !masterAccount.suspended) {
        var _masterAccount_postpaid;
        accounts.push({
            key: masterAccount.apiKey,
            postpaid: (_masterAccount_postpaid = masterAccount.postpaid) !== null && _masterAccount_postpaid !== void 0 ? _masterAccount_postpaid : false
        });
    }
    return accounts.concat(apiKeys.filter(function(param) {
        var master = param.master, suspended = param.suspended;
        return !suspended && !master;
    }).map(function(param) {
        var apiKey = param.apiKey, postpaid = param.postpaid;
        return {
            key: apiKey,
            postpaid: postpaid !== null && postpaid !== void 0 ? postpaid : false
        };
    }));
};
export var useUserAccounts = function(apiKeys) {
    var dispatch = useAppDispatch();
    var _useAuth = useAuth(), accountId = _useAuth.accountId, saveAccountId = _useAuth.saveAccountId;
    var accounts = useAppSelector(function(param) {
        var collection = param.accounts;
        return collection;
    }).accounts;
    var isAuthenticated = useValidSession();
    useUpdateCurrentAccount();
    useEffect(function() {
        if (!isAuthenticated) return;
        if (apiKeys && apiKeys.length > 0) {
            var transformedAccounts = transformMfaApiKeys(apiKeys);
            dispatch(setAccounts(transformedAccounts));
            if (transformedAccounts.length && !accountId) {
                saveAccountId(transformedAccounts[0].key);
            }
        }
    }, [
        accountId,
        apiKeys,
        dispatch,
        isAuthenticated,
        saveAccountId
    ]);
    return {
        data: accounts,
        loading: isAuthenticated === undefined || isAuthenticated && accounts.length === 0
    };
};

//# sourceMappingURL=useUserAccounts.js.map